"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formStreamPartContentDeliveryServiceId = void 0;
const formStreamPartContentDeliveryServiceId = (streamPartId) => {
    // could be "content-delivery" instead of "delivery", but that is a breaking change
    return `stream-part-delivery-${streamPartId}`;
};
exports.formStreamPartContentDeliveryServiceId = formStreamPartContentDeliveryServiceId;
//# sourceMappingURL=formStreamPartDeliveryServiceId.js.map